// extracted by mini-css-extract-plugin
module.exports = {"socialPropertyContactPage":"styles_socialPropertyContactPage__29s9G","container":"styles_container__1U-ld","label":"styles_label__1sEaa","icon":"styles_icon__2tYQY"};